import * as React from "react";
import { observer } from "mobx-react";
import { metadataStore } from "../../Stores/MetadataStore";
import { Select, Input, Empty, Form, Tooltip } from "antd";
import { Loader } from "Components/General/Loader";
import { FormInstance } from "antd/lib/form";
import { CustomFormItem } from "Components/Form/CustomFormItem";

interface MetadataFieldsProps {
  initialData?: Pick<API_DocSearchReq, "metadata">;
}

interface MetadataFieldsState extends Pick<API_DocSearchReq, "metadata"> {}

export const MetadataFields = observer(
  class MetadataFields extends React.Component<MetadataFieldsProps, MetadataFieldsState> {
    formRef: React.RefObject<FormInstance> = React.createRef();
    constructor(props: MetadataFieldsProps) {
      super(props);
      this.state = props.initialData || {};
    }

    componentDidMount() {
      this.formRef.current?.setFieldsValue({
        metadata: this.props.initialData ? this.props.initialData : {},
      });
    }

    handleSetMetadata = (key: string, value: string) => {
      this.setState(
        (prevState) => {
          // if value is not empty - set it
          if (value) {
            return { ...prevState, [key]: value };
            // otherwise remove from state
          } else {
            const nextState = { ...prevState };
            nextState[key] = undefined;
            return nextState;
          }
        },
        // set form metadata on each change
        () => this.formRef.current?.setFieldsValue({ metadata: { ...this.state } })
      );
    };

    handleInputChange = (key: string) => (value: string) => this.handleSetMetadata(key, value);

    render() {
      const { initialData } = this.props;
      if (metadataStore.state === "LOADING") {
        return <Loader />;
      }

      if (!metadataStore.data.length) {
        return <Empty />;
      }

      return (
        <Form
          ref={this.formRef}
          scrollToFirstError={true}
          initialValues={initialData}
          layout="vertical"
          name="metadataFields"
        >
          {metadataStore.data
            .filter((md) => md.show)
            .map((metadata) => {
              /* DEV-3125 - (W stands for "Wertebereich" = EN list of values.) */
              return (
                <CustomFormItem
                  fullWidth
                  label={
                    <Tooltip title={metadata.description}>
                      <span className="pointer">{metadata.key}</span>
                    </Tooltip>
                  }
                  key={metadata.definitionId}
                >
                  {/* DEV-3125 - (W stands for "Wertebereich" = EN list of values.) */}
                  <Form.Item noStyle name={metadata.key}>
                    {metadata.format.toLowerCase() === "w" ? (
                      <Select allowClear={true}>
                        {metadata.rangeList.map((item, idx) => (
                          <Select.Option key={idx} value={item.value}>
                            {item.value} - {item.description}
                          </Select.Option>
                        ))}
                      </Select>
                    ) : (
                      <Input />
                    )}
                  </Form.Item>
                </CustomFormItem>
              );
            })}
        </Form>
      );
    }
  }
);
